// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Uuid from "../../externals/Uuid.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as CatalogProductEdit__Queries from "./CatalogProductEdit__Queries.res.js";
import * as CatalogProductEditUrlQueryString from "../../modules/Catalog/CatalogProductEditUrlQueryString.res.js";

let CatalogProductEdit_ProductNotFound = /* @__PURE__ */Primitive_exceptions.create("CatalogProductEdit__Config.CatalogProductEdit_ProductNotFound");

function makeFilterBy(activeShopId) {
  return CatalogProductEdit__Queries.ProductQuery.makeInputObjectInputProductsByVariantCkuQueryFilter(activeShopId !== undefined ? CatalogProductEdit__Queries.ProductQuery.makeInputObjectInFilter([activeShopId], undefined) : undefined, "INCLUDED", undefined);
}

function initialValuesFromProductKind(productKind) {
  let initialValues = {
    name: "",
    kind: productKind,
    color: undefined,
    tax: undefined,
    categoryId: undefined,
    producer: "",
    family: "",
    designation: "",
    country: "France",
    region: "",
    beerType: "",
    wineType: undefined,
    whiteWineType: undefined
  };
  if (productKind === "BEER") {
    return {
      name: "",
      kind: productKind,
      color: "BLOND",
      tax: undefined,
      categoryId: undefined,
      producer: "",
      family: "",
      designation: "",
      country: "France",
      region: "",
      beerType: "",
      wineType: undefined,
      whiteWineType: undefined
    };
  } else if (productKind === "WINE") {
    return {
      name: "",
      kind: productKind,
      color: "RED",
      tax: undefined,
      categoryId: undefined,
      producer: "",
      family: "",
      designation: "",
      country: "France",
      region: "",
      beerType: "",
      wineType: "STILL",
      whiteWineType: undefined
    };
  } else {
    return initialValues;
  }
}

function productFromData(data) {
  let match = data.productsByVariantCku.edges[0];
  if (match !== undefined) {
    return match.node;
  }
  throw {
    RE_EXN_ID: CatalogProductEdit_ProductNotFound,
    Error: new Error()
  };
}

function productContextFromData(data) {
  let match = data.productsByVariantCku.edges[0];
  if (match !== undefined) {
    let product = match.node;
    return {
      id: product.id,
      name: product.name
    };
  }
  throw {
    RE_EXN_ID: CatalogProductEdit_ProductNotFound,
    Error: new Error()
  };
}

function use(response) {
  let shops = Auth.useShops();
  let activeShop = Auth.useActiveShop();
  let productKind = CatalogProductEditUrlQueryString.CreateProduct.decode(Navigation.useUrl().query);
  if (shops.length === 0) {
    return "Loading";
  }
  if (response.TAG === "Executed") {
    let match = response._0;
    let data = match.data;
    if (match.loading) {
      return "Loading";
    }
    if (data === undefined) {
      return "Error";
    }
    if (activeShop === undefined) {
      return "Error";
    }
    let product = productFromData(data);
    let productContext = productContextFromData(data);
    let uuid = Uuid.fromString(product.tax.id);
    return {
      TAG: "Data",
      _0: {
        initialValues: {
          name: product.name,
          kind: product.kind,
          color: product.color,
          tax: uuid !== undefined ? ({
              id: Primitive_option.valFromOption(uuid),
              value: product.tax.value
            }) : undefined,
          categoryId: Stdlib_Option.flatMap(product.category, param => {
            let uuid = Uuid.fromString(param.id);
            if (uuid !== undefined) {
              return Primitive_option.some(Primitive_option.valFromOption(uuid));
            }
          }),
          producer: Stdlib_Option.getOr(product.producer, ""),
          family: Stdlib_Option.getOr(product.family, ""),
          designation: Stdlib_Option.getOr(product.designation, ""),
          country: Stdlib_Option.getOr(product.country, ""),
          region: Stdlib_Option.getOr(product.region, ""),
          beerType: Stdlib_Option.getOr(product.beerType, ""),
          wineType: product.wineType,
          whiteWineType: product.whiteWineType
        },
        productKind: product.kind,
        contextData: productContext,
        shopName: activeShop.name
      }
    };
  }
  if (productKind.TAG !== "Ok") {
    return "Error";
  }
  if (activeShop === undefined) {
    return "Error";
  }
  let productKind$1 = productKind._0.productKind;
  return {
    TAG: "Data",
    _0: {
      initialValues: initialValuesFromProductKind(productKind$1),
      productKind: productKind$1,
      contextData: undefined,
      shopName: activeShop.name
    }
  };
}

let Query;

export {
  Query,
  CatalogProductEdit_ProductNotFound,
  makeFilterBy,
  initialValuesFromProductKind,
  productFromData,
  productContextFromData,
  use,
}
/* Auth Not a pure module */
